import Button from "components/button";
import Checkbox from "components/checkbox";
import Dropdown from "components/dropdown";
import { useState } from "react";
import { IoFilterCircleOutline } from "react-icons/io5";

function ColumnDropdown({ table }) {
  const [open, setOpen] = useState(false);

  const filteredColumns = table
    .getAllLeafColumns()
    .filter(
      (column) =>
        column.columnDef?.enableHiding !== false &&
        column.id !== "select" &&
        column.id !== "actions"
    );

  return (
    <div className="relative">
      <Dropdown
        button={
          <Button
            variant="outline"
            onClick={() => setOpen(!open)}
            open={open}
            className="dropdown-toggle flex items-center gap-2"
          >
            <IoFilterCircleOutline className="h-5 w-5" />
            <span className="hidden sm:inline">Filters </span>
            <span className="text-sm font-medium">
              (
              {
                table
                  .getAllLeafColumns()
                  .filter(
                    (column) =>
                      column.getIsVisible() &&
                      column.columnDef?.enableHiding !== false &&
                      !["select", "actions"].includes(column.id)
                  ).length
              }
              )
            </span>
          </Button>
        }
        animation={"origin-top-right transition-all duration-300 ease-in-out"}
        classNames={"top-11 right-0 w-max"}
        children={
          <div className="z-50 rounded-xl bg-white p-2 shadow-xl shadow-shadow-500 dark:bg-navy-700 dark:shadow-none">
            <ul
              className={`grid gap-2 py-1 ${
                filteredColumns.length > 3
                  ? "w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-3" // 3 columns on md+
                  : "grid-cols-1"
              }`}
            >
              {filteredColumns.map((column) => (
                <li key={column.id}>
                  <label className="flex cursor-pointer items-center gap-2 rounded-lg px-2 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300">
                    <Checkbox
                      checked={column.getIsVisible()}
                      onChange={(e) =>
                        column.toggleVisibility?.(e.target.checked)
                      }
                    />
                    <span className="whitespace-nowrap text-gray-500 dark:text-gray-400">
                      {column?.id === "select"
                        ? "Checkbox"
                        : column.columnDef.header}
                    </span>
                  </label>
                </li>
              ))}
            </ul>
          </div>
        }
      />
    </div>
  );
}

export default ColumnDropdown;
